<template>
	<div
		class="module-f-seo"
		:data-chronicle="chronicId"
		data-e2e="f-seo"
		data-module-type="link-list"
		data-metrics-module="f-seo"
		v-if="items && items.length > 0"
	>
		<div class="f-seo-container">
			<h3>Related Links</h3>
			<ul>
				<li
					v-for="(item, index) in items"
					:key="item.title"
				>
					<a
						v-if="item.link"
						:href="item.link"
						:data-metrics-link="index + 1"
						v-metric="{link: index + 1}"
					>
						{{ item.text }}
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

export default {
	name: 'ChannelSeoLinks',

	props: {
		chronicId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			metrics: {
				module: 'f-seo',
			},
			items: [],
			moduleData: [],
			marginTop: 0,
		};
	},
	computed: {
		getItems() {
            const module = this.moduleData;
 
            // short circuit if module malformed
            if (Object.keys(module).length === 0) {
                return [];
            }
            const tempItems = module.links.link.map((link) => ({
                text: link.link_text || '',
                link: 'link_friendlyUrl' in link ? link.link_friendlyUrl : '',
            })) || [];
 
            const items = tempItems.filter((i) => i && i.link);
 
            return items;
        },

		getModuleData() {
			let result = [];

			// eslint-disable-next-line max-len
			const module = this.store.cms.getModules(this.chronicId);

			// set the moduleData if found
			if (module && module.module_data) {
				result = module.module_data;
			}

			return result;
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		this.moduleData = this.getModuleData;
		this.items = this.getItems;
		this.store.cms.SET_RENDERED(this.chronicId);
	},
};

</script>

<style lang="scss">
@import 'stylesheets/variables.scss';
.module-f-seo {
	border-top: 1px solid var(--sf-primary-a);
	font-family: $base-font-family-sans;
	padding: 2.25rem 0;
	position: relative;

	@media screen and (min-width: 47.9375rem) and (max-width: 64rem) {
		max-width: 45.5rem;
		margin: 0 auto;
	}

	@media screen and (max-width: 47.9375rem) {
		padding: 2.25rem 1.5rem;
	}

	@media screen and (min-width: 64.0625rem) and (max-width: 77.5rem) {
		padding: 2.25rem 1.5rem;
	}

	.f-seo-container {
		max-width: 77.5rem;
		margin: 0 auto;
	}

	h3 {
		border-bottom: 0.063rem solid #C6CEDB;
		color: $imperial;
		font-family: var(--sf-font-family, $base-font-family-sans);
		font-weight: 700;
		font-size: 1.25rem;
        line-height: 1.563rem;
        letter-spacing: 0.05em;
		margin: 0 0 px2rem(30) 0;
		margin-bottom: 1.531rem;
        padding-bottom: 0.969rem;
        text-transform: uppercase;
	}

	ul {
		column-count: 4;
		column-gap: 1.5rem;
		list-style-type: none;
		margin: 0 auto;
		padding: 0;

		@media screen and (max-width: $breakpoint-tablet) {
			column-count: 3;
		}

		@media screen and (max-width: $breakpoint-mobile) {
			column-count: 1;
		}

		li {
			margin-bottom: px2rem(24);
			margin-right: px2rem(24);
		}

		a {
			color: $carbon;
			font-size: 1rem;
			line-height: 1.625;
			text-decoration: none;
			&:hover {
            color: $ultramarine;
			}
		}
	}
}

</style>
